export var getTextAlign = function getTextAlign(index) {
  return index === 0 ? 'left' : 'center';
};